import {IVehiclePropertyColor} from './IVehiclePropertyColor';

export interface IVehiclePropertyBase {
	propertyId: string;
	value: string;
	priority: number;
}

export const isIVehiclePropertyBase = (obj: any): obj is IVehiclePropertyBase => {
	return obj.propertyId !== 'undefined' && obj.value !== 'undefined' && obj.priority !== 'undefined';
};

export const isIVehiclePropertyColor = (obj: any): obj is IVehiclePropertyColor => {
	return obj.hexValue !== 'undefined' && isIVehiclePropertyBase(obj);
};
